import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { AuditCard } from "@/features/Audit/AuditCard";
import { D1TimeSeriesEditCard } from "./edit_card";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";
import { Clients } from "@/lib/clients";

import { Tables } from "@/gen/tableNames/tables";

export const D1TimeSeriesEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <D1TimeSeriesEditCard
          id={Number(id)}
          client={Clients.D1}
          table_name={Tables.D1_TIME_SERIES}
        />
        <TechnicalInfoCard
          id={Number(id)}
          table_name={Tables.D1_TIME_SERIES}
          client={Clients.D1}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.D1}
          audit_table_name={Tables.D1_TIME_SERIES}
        />
      </div>
    </div>
  );
};
